
import { Avatar, Box, Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { stringAvatar } from 'components/DataGrid/gridOperators'
import { DensityStyleTypes } from '../../../../types'

interface RenderOrgCellProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
  navigate: (route: string) => void
}

const RenderDealOrganizationCell: React.FC<RenderOrgCellProps> = ({ params, densityStyles, navigate }) => {
  const { PK, photoUrl, name } = params?.row?.organization ?? {}

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'left',
        alignItems: 'center',
        height: '100%',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
      }}
      onClick={() => navigate(PK ? `/organizations/${PK}/details` : '#')}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'left',
          height: '100%',
          width: '100%',
          fontWeight: 'bold',
          cursor: 'pointer',
          gap: 1,
        }}
      >
        {photoUrl ? (
          <Avatar
            src={photoUrl}
            sx={{
              width: densityStyles.avatarSize,
              height: densityStyles.avatarSize,
              objectFit: 'cover',
              objectPosition: 'center',
            }}
            alt={name}
          />
        ) : (
          <Avatar
            {...stringAvatar(name, densityStyles)}
            sx={{
              backgroundColor: 'rgb(114, 229, 218)',
              width: densityStyles.avatarSize,
              height: densityStyles.avatarSize,
              objectFit: 'cover',
              objectPosition: 'center',
            }}
          />
        )}

        <Typography
          sx={{
            fontSize: densityStyles.fontSize,
            display: 'flex',
            justifyContent: 'left',
            alignItems: 'center',
            width: '100%',
            height: '100%',
          }}
        >
          {name}
        </Typography>
      </Box>
    </Box>
  )
}
export default RenderDealOrganizationCell
